import React, {useState, useEffect, useCallback, useRef} from 'react';
import {
    Container,
    Button,
    Grid,
    CircularProgress,
    TextField, FormControlLabel,
} from '@mui/material';
import { Alert } from '@mui/material';
import {Link as RouterLink, useParams, useHistory} from 'react-router-dom';
import {useForm, Controller} from 'react-hook-form';
import {GasCountryService} from '../shared/service';
import ValidationError from "../../shared/ValidationError";
import {DataGrid} from "@mui/x-data-grid";
import Link from "@mui/material/Link";
import {Check, X} from 'react-feather';
import Select from "react-select";
import Prompt from "../../../customUtil/Prompt";

const columns = [
    {
        field: 'person.name', headerName: 'Name', width: 230,
        renderCell: (params) => (
            <Link component={RouterLink} to={'/gas/contact/' + params.row.id}>
                {params.row.person.name}
            </Link>
        )
    },
    {
        field: 'person.title', headerName: 'Title', width: 200, renderCell: (params) => (
            <>{params.row.person.title}</>
        )
    },
    {
        field: 'person.email', headerName: 'Email', width: 300, renderCell: (params) => (
            <>{params.row.person.email}</>
        )
    },
    {
        field: 'active', headerName: 'Is Active', width: 200, renderCell: (params) => (
            <>{params.value ? <Check/> : <X></X>}</>
        )
    }
]


const CountryForm = () => {
    const methods = useForm();
    const {handleSubmit, control, setValue, errors} = methods;

    const [data, setData] = useState({});
    const [countries, setCountries] = useState([]);
    const [message, setMessage] = useState('');
    const [isReady, setIsReady] = useState(false);
    const [submitEnabled, setSubmitEnabled] = useState(true);
    const [showMerge, setShowMerge] = useState(false);
    const [selectedMergeCountry, setSelectedMergeCountry] = useState('');
    const {id} = useParams();
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    
    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
      const [isVisibleDialog, setVisibleDialog] = useState(false);

    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );
      
      useEffect(() => {
       
        const unblock = history.block((location) => {
          if (location.pathname !== `/gas/account-statements/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);

    useEffect(() => {
        GasCountryService.getAll().then((response) => {
            setCountries(response.data);
        })
        if (id !== "new") {
            GasCountryService.getById(id).then((response) => {
                setData(response.data);
                window.da = response.data;
                setIsReady(true);
            });
        } else {
            setData({countryPeople: []});
            setIsReady(true);
        }
    }, [id, setValue]);


    const onMergeClicked = () => {
        GasCountryService
            .mergeCountry(selectedMergeCountry, data.id).then((response) => {
                setMessage("Country merged successfully. Please do not edit this record any more.");
                setSubmitEnabled(false);
             });
    }

    const onSubmit = d => {
        setBlock(false);
        setVisibleDialog(false);
        if (data.id) {
            GasCountryService.update({...data, ...d}).then((response) => {
                setMessage('Country updated.')
            });
        } else {
            GasCountryService.create({...data, ...d}).then((response) => {
                setData(response.data);
                setMessage('Country Created.');
            });
        }
    };

    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     
   
      const onSave = (event) => {
          console.log(event)
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }

    return (
        <Container>
            <header>
                <h1>GAS Country</h1>
            </header>
            {
                message && <Alert severity="success">{message}</Alert>
            }
            <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
            <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <p>
                            Use this form to create / edit country and contact details.
                        </p>
                    </Grid>

                    <Grid item xs={6}>
                        <Controller
                            name="name"
                            control={control}
                            fullWidth
                            as={<TextField></TextField>}
                            label="Name"
                            color="primary"
                            variant="outlined"
                            rules={{required: 'Name is required.'}}
                            defaultValue={data.name}
                        />
                        <ValidationError error={errors.name}/>
                    </Grid>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <Controller
                            name="code"
                            control={control}
                            fullWidth
                            as={TextField}
                            label="Code"
                            color="primary"
                            variant="outlined"
                            rules={{required: 'Code is required.'}}
                            defaultValue={data.code}
                        />
                        <ValidationError error={errors.code}/>
                    </Grid>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <Controller
                            name="primaryPrs"
                            control={control}
                            fullWidth
                            as={TextField}
                            label="Primary PRS"
                            color="primary"
                            variant="outlined"
                            disabled
                            defaultValue={data.primaryPrs && data.primaryPrs.person.email}
                        />
                        <ValidationError error={errors.code}/>
                    </Grid>
                    <Grid item xs={12}>
                        {
                            !showMerge &&
                            <Button  type="button" color="secondary" onClick={() => setShowMerge(true)}>Merge Country</Button>
                        }
                    </Grid>
                    {
                        showMerge &&
                        <>
                            <Grid item xs={2}>
                                <FormControlLabel label="Merge to Country" variant="outlined" labelPlacement="bottom"
                                                  control={<></>}/>
                            </Grid>
                            <Grid item xs={4}>
                                <Controller
                                    name="gasCountry"
                                    control={control}
                                    label="Country"
                                    color="primary"
                                    rules={{required: 'Country is required.'}}
                                    variant="outlined"
                                    defaultValue={data.gasCountry && data.gasCountry.id}
                                    render={(
                                        {onChange, onBlur, value, name, ref},
                                        {invalid, isTouched, isDirty}
                                    ) => (
                                        <Select
                                            menuPlacement="auto"
                                            menuPosition="fixed"
                                            options={countries.map(r => ({value: r.id, label: r.name}))}
                                            value={countries.map(r => ({
                                                value: r.id,
                                                label: r.name
                                            })).filter(c => value === c.value)}
                                            onChange={val => {
                                                onChange(val.value);
                                                setSelectedMergeCountry(val.value);
                                            }}
                                            inputRef={ref}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                {
                                    selectedMergeCountry &&
                                    <Button disabled={!submitEnabled} onClick={() => onMergeClicked()} variant="contained" color="primary" type="button">Merge</Button>
                                }
                            </Grid>
                        </>
                    }

                    <Grid item xs={12}>
                        <DataGrid
                            rowHeight={35}
                            autoHeight={true}
                            rows={data.countryPeople}
                            columns={columns}
                            pageSize={20}/>
                    </Grid>
                    <Grid item xs={12}>
                        <Button disabled={!submitEnabled} variant="contained" color="primary" type="submit">Submit</Button>
                    </Grid>
                </Grid>
                <button hidden={true} ref={refSubmitButtom} type={"submit"} />
            </form>
        </Container>
    );
};

export default CountryForm;
